import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { ConvertToDate, ConvertToString } from '../../../services/dates';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    position: relative;
    height: 25px;
    width: 110px;
    background-color: #111;
    border: 1px solid #999;

    &.mb {
        margin-bottom: 10px;
    }
    &.mr {
        margin-right: 5px;
    }
`;

const Input = styled.input`
    position: relative;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    color: #fff;
    background-color: transparent;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    border: 0px;
`;

const Icon = styled.div`
    position: absolute;
    height: 23px;
    width: 23px;
    top: 0;
    right: 0;

    &:before {
        color: #999;
        font-size: 14px;
        font-family: 'Material Design Icons';
        content: '\\F00EE';
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
`;

export default ({onChange, value, ...props}) => {
    const [date, setDate] = useState("");
    const className = props.className ?? '';
    const width = props.width ?? null;

    const handleChange = (e) => {
        let val = e.target.value.replace(/[^\d\/]/gi,'');
        let [day, month, year] = val.split("/");
        let hasBarMonth = Boolean(month);
        let hasBarYear = Boolean(year);

        if (day.length >= 2 && (month === undefined || month.length < 2)) {
            day = day.substring(0,2);
            month = hasBarMonth ? month : day.substring(2,4);
            hasBarMonth = true;
        }

        if (month && month.length >= 2 && (year === undefined || year.length < 4)) {
            month = month.substring(0,2);
            year = hasBarYear ? year : month.substring(2,6);
            hasBarYear = true;
        }

        let result = day.substring(0,2) + (hasBarMonth ? "/" : "") + (month ? month.substring(0,2) : '') + (hasBarYear ? "/" : "") + (year ? year.substring(0,4) : '');
        result = result.substring(0,10);
        
        setDate(result);
    };

    const handleBlur = (e) => {
        let [day, month, year] = date.split("/").map((i)=>parseInt(i));

        if (!day || !month || !year) {
            setDate("");
            return;
        }
        
        let dt = new Date();
        dt.setUTCFullYear(year);
        dt.setUTCMonth(month-1);
        dt.setUTCDate(day);

        if (dt.getUTCFullYear() === year && dt.getUTCMonth() === month-1 && dt.getUTCDate() === day) {
            if (onChange && typeof onChange === 'function') {
                onChange(date, dt);
            }
        } else {
            setDate("");
        }
        
    }


    useEffect(() => {
        setDate(value);
    }, [value]);

    return <Container className={className} width={width}>
        <Icon />
        <Input value={date} onChange={handleChange} onBlur={handleBlur} />
    </Container>
}